import { useMutation, useQueryClient } from '@tanstack/react-query'
import api from '../../api'
import type { MongoDBCreateRequest } from '../../types/mongodb'

const useCreateNewMongoDB = () => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (request: MongoDBCreateRequest) =>
			api.mongodb.createNewMongoDB(request),
		onSuccess: () => {
			void queryClient.invalidateQueries({ queryKey: ['mongodb'] })
			void queryClient.invalidateQueries({ queryKey: ['mongodb-eligibility'] })
		}
	})
}

export default useCreateNewMongoDB
